module.exports = __webpack_public_path__ + "static/Nanin-96a52d754390c6bbd67f4b895520d2f2.jpg";